import { React, Fragment, memo, useEffect, useState } from 'react'
import {
  HeadingText,
  BodyText,
  Row,
  Col,
  Avatar,
  Button,
  Link,
} from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { fptiCustomImpression } from '../../../utils'
import { VENMO_CONTACTUS } from '../../../constants/constants'

const SomethingWrong = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(props.fpti.PASSWORD_SOMETHING_WRONG)
    }
  }, [])

  const handleTryAgain = (event) => {
    event.preventDefault()
    location.reload()
  }

  return (
    <Fragment>
      <div className="flex-center">
        <Avatar
          src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-warning.svg"
          className="focusedimg"
          alt="error"
        />
      </div>

      <HeadingText
        size="sm"
        id="password-recovery-somethingwrong"
        className="text-center requestForm-row"
      >
        <Message id="closedAccountPages.somethingwentwrong.title" />
      </HeadingText>

      <Row>
        <Col>
          <BodyText className="text-center requestForm-row">
            <Message
              id="closedAccountPages.somethingwentwrong.description_2"
              link={(innerMessage) => (
                <Link name="contactus" href={VENMO_CONTACTUS}>
                  {innerMessage}
                </Link>
              )}
            />
          </BodyText>
        </Col>
      </Row>
      <div className="text-center requestForm-row">
        <Button id="tryagainbtn-sw" onClick={handleTryAgain}>
          <Message id="closedAccountPages.tryagainbtn.lable" />
        </Button>
      </div>
    </Fragment>
  )
})

SomethingWrong.displayName = 'SomethingWrong'
export default SomethingWrong
